// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__pNkhv","rotating":"loading_rotating__2MnoC"};